module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABOUlEQVQ4T7XUv0vDQBQH8O97F2txEPwP6mIWwdTJzd1VLBUFB0FFBH8EnByCuEqVItjFRaHazoKri4ugRRDspIKjk4Nam9wT46KkpqkkNz8+73t3744Q06KYHASgq+pqnsHlsAbiev3ZyZ2HnzXJQbXjtQFSGAtL9NZoHoxMF18CiS4Pl81UWi2KoLeTMyPCM7i5OzRefPK3VqvY9yBk2iKCOpM+0oI8iE5IyBHoGytXyH5DVVvaIgBI5Mxz9SYrXvdc2lJduAAhZU1sU0fQX80CEEHva5FSlHRMNC/gha/aFpA4niunysBsGPb++rGR7uleEpDzG6rYdyCYBHE8SD3KQLLBMz4k+tbKFQb9M7our2TY4DnRdK5Z90WBiJUpkFFxG6Xhqb3H5CY7trcW5cZa1ST3jfw30Se8QJATabZhIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/newCode/formPrint/iconSVG-.png
// module id = 1211
// module chunks = 2